/** Geodaten fuer Karten-Kacheln in der App (angemeldet): ueber die Datenabfrage, auch fuer interne Datensaetze. */
import { api } from './api.js';
import { geoSql, type GeoRow } from './geo-features.js';

export async function loadGeoFeaturesApp(slug: string, limit: number): Promise<GeoRow[]> {
  const d = await api.getDatasetBySlug(slug);
  const sql = geoSql(d, limit);
  if (!sql) throw new Error(`Der Datensatz „${d.title}“ enthält keine Geodaten.`);
  const res = await api.dataQuery(sql);
  return res.rows as GeoRow[];
}
